import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generateInvoicePDF = (invoice) => {
  const doc = new jsPDF();

  // 🔲 BORDER
  doc.rect(5, 5, 200, 287);

  // ===============================
  // 🏢 COMPANY HEADER
  // ===============================
  doc.setFontSize(14);
  doc.text("YOUR COMPANY NAME", 10, 15);

  doc.setFontSize(9);
  doc.text("Address Line 1, City", 10, 20);
  doc.text(`GSTIN: ${invoice.company_gstin || "-"}`, 10, 25);

  // ===============================
  // 📄 INVOICE INFO (RIGHT)
  // ===============================
  doc.setFontSize(12);
  doc.text("TAX INVOICE", 150, 15);

  doc.setFontSize(9);
  doc.text(`Invoice No: ${invoice.invoice_no}`, 140, 22);
  doc.text(`Date: ${invoice.invoice_date}`, 140, 27);
  doc.text(`Status: ${invoice.status}`, 140, 32);

  // ===============================
  // 👤 BILL TO (LEFT BOX)
  // ===============================
  doc.rect(5, 40, 100, 35);
  doc.text("Bill To:", 7, 45);

  doc.setFontSize(9);
  doc.text(`Customer ID: ${invoice.customer_id || "-"}`, 7, 50);
  doc.text(`Customer GSTIN: ${invoice.customer_gstin || "-"}`, 7, 55);
  doc.text(`DC Ref: ${invoice.dc_out_id}`, 7, 60);

  // ===============================
  // 🚚 SUPPLY DETAILS (RIGHT BOX)
  // ===============================
  doc.rect(105, 40, 100, 35);
  doc.text("Supply Details:", 107, 45);

  doc.text(`Place: ${invoice.place_of_supply || "-"}`, 107, 50);
  doc.text(`GST %: ${invoice.gst_percent}%`, 107, 55);

  // ===============================
  // 📊 ITEMS TABLE
  // ===============================
  const items = invoice.items.map((item, i) => [
    i + 1,
    item.item_name,
    item.qty,
    Number(item.price).toFixed(2),
    Number(item.amount).toFixed(2),
  ]);

  autoTable(doc, {
    startY: 80,
    head: [["#", "Particulars", "Qty", "Rate", "Amount"]],
    body: items,
    theme: "grid",
    styles: { fontSize: 9 },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
    },
  });

  let y = doc.lastAutoTable.finalY + 5;

  // ===============================
  // 💰 TOTAL BOX (RIGHT SIDE)
  // ===============================
  doc.setFontSize(9);

  doc.text("Subtotal:", 140, y);
  doc.text(`₹ ${Number(invoice.subtotal).toFixed(2)}`, 200, y, {
    align: "right",
  });
  y += 5;

  doc.text("CGST:", 140, y);
  doc.text(`₹ ${Number(invoice.cgst).toFixed(2)}`, 200, y, {
    align: "right",
  });
  y += 5;

  doc.text("SGST:", 140, y);
  doc.text(`₹ ${Number(invoice.sgst).toFixed(2)}`, 200, y, {
    align: "right",
  });
  y += 5;

  doc.text("IGST:", 140, y);
  doc.text(`₹ ${Number(invoice.igst).toFixed(2)}`, 200, y, {
    align: "right",
  });
  y += 5;

  doc.setFont(undefined, "bold");
  doc.text("Total:", 140, y);
  doc.text(`₹ ${Number(invoice.total).toFixed(2)}`, 200, y, {
    align: "right",
  });
  doc.setFont(undefined, "normal");

  y += 10;

  // ===============================
  // 💳 PAYMENT SECTION
  // ===============================
  doc.text("Payment Details:", 10, y);
  y += 5;

  if (invoice.payments.length > 0) {
    const payments = invoice.payments.map((p, i) => [
      i + 1,
      p.date || "-",
      p.method || "-",
      `₹ ${p.amount || 0}`,
    ]);

    autoTable(doc, {
      startY: y,
      head: [["#", "Date", "Method", "Amount"]],
      body: payments,
      theme: "grid",
      styles: { fontSize: 9 },
    });

    y = doc.lastAutoTable.finalY + 5;
  } else {
    doc.text("No payments recorded", 10, y);
    y += 5;
  }

  // ===============================
  // 💰 BALANCE SUMMARY
  // ===============================
  const balance =
    Number(invoice.total) - Number(invoice.paid_amount);

  doc.text(`Paid: ₹ ${Number(invoice.paid_amount).toFixed(2)}`, 140, y);
  y += 5;

  doc.text(`Balance: ₹ ${balance.toFixed(2)}`, 140, y);

  y += 20;

  // ===============================
  // ✍ SIGNATURE
  // ===============================
  doc.text("Authorized Signatory", 140, y);

  // ===============================
  // 📥 DOWNLOAD
  // ===============================
  doc.save(`${invoice.invoice_no}.pdf`);
};